import { EmissionScope, Scope1ActivityType, Scope2ActivityType } from '../types/emissions';

export const SCOPE1_ACTIVITY_TYPE_LABELS: Record<Scope1ActivityType, string> = {
  [Scope1ActivityType.StationaryCombustion]: 'Stationary Combustion',
  [Scope1ActivityType.MobileCombustion]: 'Mobile Combustion',
  [Scope1ActivityType.FugitiveEmissions]: 'Fugitive Emissions',
  [Scope1ActivityType.ProcessEmissions]: 'Process Emissions',
};

export const getActivityTypeLabel = (type: Scope1ActivityType): string =>
  SCOPE1_ACTIVITY_TYPE_LABELS[type];

/**
 * Get valid activity types for a given scope
 */
export const getActivityTypesForScope = (scope: EmissionScope): string[] => {
  if (scope === EmissionScope.Scope1) {
    return Object.values(Scope1ActivityType);
  }
  return Object.values(Scope2ActivityType);
};

/**
 * Get human-readable scope label
 */
export const getScopeLabel = (scope: EmissionScope): string => {
  return scope === EmissionScope.Scope1
    ? 'Scope 1 - Direct Emissions'
    : 'Scope 2 - Purchased Energy';
};
